import { Text } from "@clipboard-health/ui-react";
import { Box, Button, Drawer, Stack } from "@mui/material";
import { useState } from "react";

import { useIsSmallScreen } from "../../hooks/useIsSmallScreen";
import { HyperTrackEmbeddedView } from "../HyperTrackEmbeddedView";
import { useShiftCardContext } from "../useShiftCard";

export function ShiftBoardLiveTrackerMapView() {
  const { shift, distanceInMiles } = useShiftCardContext();
  const { trip } = shift;
  const isSmallScreen = useIsSmallScreen();
  const [isOpen, setIsOpen] = useState(false);
  const { eta, trackingUrl } = trip ?? {};

  if (isSmallScreen) {
    return (
      <Stack justifyContent="center" alignItems="center">
        <Button
          variant="outlined"
          sx={{ width: "100%", borderRadius: 3 }}
          onClick={() => {
            setIsOpen(true);
          }}
        >
          <Text variant="h4">View tracking map</Text>
        </Button>
        <Drawer
          open={isOpen}
          anchor="bottom"
          sx={{
            "& .MuiDrawer-paper": {
              borderTopLeftRadius: 32,
              borderTopRightRadius: 32,
            },
          }}
          onClose={() => {
            setIsOpen(false);
          }}
        >
          <Box
            sx={{
              height: "80vh",
              display: "flex",
              flexDirection: "column",
              backgroundColor: "white",
            }}
          >
            <Stack justifyContent="space-between" alignItems="center" height="100%">
              <Stack padding={2} alignItems="center">
                <Text variant="h1">Tracking Map</Text>
                <Text variant="h4">A live map to see where your worker is</Text>
                <Stack paddingTop={1} direction="row" gap={2}>
                  <Text variant="body2">
                    Distance:{" "}
                    <span style={{ color: "black" }}>{Math.round(distanceInMiles ?? 0)} mi</span>
                  </Text>
                  <Text variant="body2">
                    ETA:{" "}
                    <span style={{ color: "black" }}>
                      {Math.round(eta?.durationInMin ?? 0)} mins
                    </span>
                  </Text>
                </Stack>
              </Stack>
              <HyperTrackEmbeddedView trackingUrl={trackingUrl} height="100%" />
            </Stack>
          </Box>
        </Drawer>
      </Stack>
    );
  }

  return <HyperTrackEmbeddedView trackingUrl={trackingUrl} aspectRatio="4 / 3" />;
}
